import styles from '../InternalExternalDetail.module.css'
import SkillsBlock from './SkillsBlock'

const CareerHistoryItem = ({ logo, logoBg, logoColor, role, company, period, description, skills }) => (
  <div className={styles.historyItem}>
    <div
      className={styles.companyLogo}
      style={{ background: logoBg, color: logoColor }}
    >
      <span>{logo}</span>
    </div>

    <div className={styles.historyBody}>
      <div className={styles.historyTop}>
        <div>
          <h4 className={styles.historyRole}>{role}</h4>
          <div className={styles.historyCompany}>{company}</div>
          <div className={styles.historyPeriod}>{period}</div>
        </div>
      </div>

      {description.length > 0 && (
        <ul className={styles.historyBullets}>
          {description.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      )}

      {skills.length > 0 && <SkillsBlock skills={skills} chipVariant="chipGray" />}
    </div>
  </div>
)

export default CareerHistoryItem
